import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Flame, Award, Calendar, Clock, TrendingUp } from "lucide-react";

export function AnalyticsTab({
  usageStats,
  assessmentSummary
}) {
  return (
    <div className="space-y-4">
      {/* Usage Stats - Responsive 2x2 on mobile, 4-col on desktop */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
        <Card className="bg-orange-50 border-orange-200">
          <CardContent className="py-2.5 px-3 sm:py-3 sm:px-4 text-center">
            <Flame className="h-4 w-4 sm:h-5 sm:w-5 mx-auto text-orange-600 mb-1" />
            <p className="text-lg sm:text-xl font-bold text-orange-700">{usageStats?.current_streak || 0}</p>
            <p className="text-[10px] sm:text-xs text-orange-600 font-medium truncate">Streak</p>
          </CardContent>
        </Card>
        <Card className="bg-purple-50 border-purple-200">
          <CardContent className="py-2.5 px-3 sm:py-3 sm:px-4 text-center">
            <Award className="h-4 w-4 sm:h-5 sm:w-5 mx-auto text-purple-600 mb-1" />
            <p className="text-lg sm:text-xl font-bold text-purple-700">{usageStats?.longest_streak || 0}</p>
            <p className="text-[10px] sm:text-xs text-purple-600 font-medium truncate">Best</p>
          </CardContent>
        </Card>
        <Card className="bg-blue-50 border-blue-200">
          <CardContent className="py-2.5 px-3 sm:py-3 sm:px-4 text-center">
            <Calendar className="h-4 w-4 sm:h-5 sm:w-5 mx-auto text-blue-600 mb-1" />
            <p className="text-lg sm:text-xl font-bold text-blue-700">{usageStats?.total_active_days || 0}</p>
            <p className="text-[10px] sm:text-xs text-blue-600 font-medium truncate">Active Days</p>
          </CardContent>
        </Card>
        <Card className="bg-emerald-50 border-emerald-200">
          <CardContent className="py-2.5 px-3 sm:py-3 sm:px-4 text-center">
            <Clock className="h-4 w-4 sm:h-5 sm:w-5 mx-auto text-emerald-600 mb-1" />
            <p className="text-lg sm:text-xl font-bold text-emerald-700">{usageStats?.daily_average_minutes || 0}</p>
            <p className="text-[10px] sm:text-xs text-emerald-600 font-medium truncate">Mins Today</p>
          </CardContent>
        </Card>
      </div>

      {/* Progress Over Time - Compact */}
      <Card>
        <CardHeader className="py-3 px-4">
          <CardTitle className="flex items-center gap-2 text-base">
            <TrendingUp className="h-4 w-4 text-blue-600" />
            Learning Progress
          </CardTitle>
          <CardDescription className="text-xs">Track improvement over time</CardDescription>
        </CardHeader>
        <CardContent className="pt-0 pb-3 px-4">
          <div className="space-y-4">
            <div>
              <div className="flex justify-between mb-1">
                <span className="text-xs font-medium">Overall Accuracy</span>
                <span className="text-xs font-medium">{assessmentSummary?.accuracy_percent || 0}%</span>
              </div>
              <Progress value={assessmentSummary?.accuracy_percent || 0} className="h-2" />
            </div>
            
            <div>
              <div className="flex justify-between mb-1">
                <span className="text-xs font-medium">Daily Goal Progress</span>
                <span className="text-xs font-medium">{Math.min(100, Math.round((usageStats?.daily_average_minutes || 0) / 60 * 100))}%</span>
              </div>
              <Progress value={Math.min(100, Math.round((usageStats?.daily_average_minutes || 0) / 60 * 100))} className="h-2" />
            </div>

            <div className="bg-blue-50 rounded-md p-3">
              <h4 className="font-medium text-blue-900 text-sm mb-1.5">Tips to Improve</h4>
              <ul className="text-xs text-blue-800 space-y-0.5">
                <li>• Practice consistently every day to build a streak</li>
                <li>• Focus on subjects with lower accuracy</li>
                <li>• Review incorrect answers to learn from mistakes</li>
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
